var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrograms(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Programs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Programs",
    stroke: "#B7844D",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21424165,0.112192815 L0.198283821,6.8647511 C0.06684003,6.98100926 0.00374954859,7.05506418 0,7.183268 L0,17.5922984 C0,17.8057098 0.183270244,18 0.384569086,18 L16.614538,18 C16.8158407,18 16.9991071,17.8057037 16.9991071,17.5922984 L16.9991071,7.29151278 C17.0081195,7.08289186 16.9495342,7.00006727 16.7948048,6.8583298 L8.80903543,0.124933491 C8.61825263,-0.0422873717 8.40719919,-0.0367140904 8.21414551,0.112192815 L8.21424165,0.112192815 Z M8.50288281,0.72 L16.2272727,7.3505125 L16.2272727,17.28 L0.772727273,17.28 L0.772727273,7.3505125 L8.50288281,0.72 Z",
    id: "Fill-1",
    strokeWidth: 0.5,
    fill: "#B7844D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.5,
    x: 6.75,
    y: 13.75,
    width: 3.5,
    height: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograms);
export default __webpack_public_path__ + "static/media/Programs.c26feecc46c1520fdfc6ef7188ad76f8.svg";
export { ForwardRef as ReactComponent };